(() => {
    angular
        .module('trackingReportsModule', ['ngAnimate', 'journey.canvas.srv'])
        .controller('trackingReportsCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', '$compile', '$location', ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache, $compile, $location) => {
            $scope.mainView = true;
            $scope.innerView = false;
            $scope.trackerData = [];

            $rootScope.$watch('translate', (func) => {
                if(func) {
                    $scope.translate = func;
                }
            });

            $rootScope.$on('trackingReports', (e) => {
                $scope.mainView = true;
                $scope.innerView = false;
                $scope.tracking = true;
                $scope.getMainTrackerData('2017-01-01');
                $rootScope.$emit('setBodyOverflow');
            });

            $scope.filterMainBy = (filter) => {
                let startDate = '2017-01-01';

                let date = new Date();
                if(filter == 'oneDay') {
                    date.setDate(date.getDate() - 1);
                    const dd = date.getDate();
                    const mm = date.getMonth()+1; //January is 0!
                    const yyyy = date.getFullYear();

                    startDate = `${yyyy}-${mm}-${dd}`;
                }

                if(filter == 'oneWeek') {
                    date.setDate(date.getDate() - 7);
                    const dd = date.getDate();
                    const mm = date.getMonth()+1; //January is 0!
                    const yyyy = date.getFullYear();

                    startDate = `${yyyy}-${mm}-${dd}`;
                }

                if(filter == 'oneMonth') {
                    date.setDate(date.getDate() - 30);
                    const dd = date.getDate();
                    const mm = date.getMonth()+1; //January is 0!
                    const yyyy = date.getFullYear();

                    startDate = `${yyyy}-${mm}-${dd}`;

                }

                $scope.getMainTrackerData(startDate, 'filter')
            };

            $scope.filterInnerBy = (filter) => {
                let startDate = '2017-01-01';
                const endDate = $scope.calcEndDate();

                let date = new Date();
                if(filter == 'oneDay') {
                    date.setDate(date.getDate() - 1);
                    const dd = date.getDate();
                    const mm = date.getMonth() + 1; //January is 0!
                    const yyyy = date.getFullYear();

                    startDate = `${yyyy}-${mm}-${dd}`;
                }

                if(filter == 'oneWeek') {
                    date.setDate(date.getDate() - 7);
                    const dd = date.getDate();
                    const mm = date.getMonth() + 1; //January is 0!
                    const yyyy = date.getFullYear();

                    startDate = `${yyyy}-${mm}-${dd}`;
                }

                if(filter == 'oneMonth') {
                    date.setDate(date.getDate() - 31);
                    const dd = date.getDate();
                    const mm = date.getMonth() + 1; //January is 0!
                    const yyyy = date.getFullYear();

                    startDate = `${yyyy}-${mm}-${dd}`;

                }

                $scope.getInnerTrackerData(startDate, 'filter');
            };

            $scope.calcEndDate = () => {
                const today = new Date();
                const dd = today.getDate();
                const mm = today.getMonth()+1; //January is 0!
                const yyyy = today.getFullYear();

                return `${yyyy}-${mm}-${dd}`;
            };

            $scope.getMainTrackerData = (startDate, isFilter) => {
                $scope.loading = true;
                const endDate = $scope.calcEndDate();

                canvasService.getTrackerSummary(startDate, endDate)
                    .then(({data}) => {
                        $scope.trackerData = data.TrackerInformations;
                        if(isFilter) {
                            if($scope.trackerData.length) {
                                $scope.noRecordsFound = false;
                            } else {
                                $scope.noRecordsFound = true;
                            }
                        } else {
                            if($scope.trackerData.length) {
                                $scope.emptyState = false;
                            } else {
                                $scope.emptyState = true;
                            }
                        }
                        $scope.loading = false;
                    })
                    .catch(() => { $scope.loading = false; });
            };

            $scope.getInnerTrackerData = (startDate, isFilter) => {
                const endDate = $scope.calcEndDate();
                $scope.tDetails = [];
                $scope.mainView = false;
                $scope.innerView = true;
                $scope.loading = false;

                canvasService.getTrackerSummaryDetails(startDate, endDate, $scope.currentUrl)
                    .then(({data}) => {
                        $scope.tDetails = data.TrackerInformations;
                        if(isFilter) {
                            if($scope.tDetails.length) {
                                $scope.noRecordsFound = false;
                            } else {
                                $scope.noRecordsFound = true;
                            }
                        }
                    });
            };

            $scope.displayTracking = () => {
                if($rootScope.isHome_Global) {
                    $rootScope.$emit('displayTrackingHome');
                } else {
                    $rootScope.$emit('displayTrackingCanvas');
                }
            };

            $scope.close = () => {
                $scope.tracking = false;
                $rootScope.$emit('removeBodyOverflow');
            };

            $scope.displayInnerView = (url) => {
                $scope.currentUrl = url;
                $scope.getInnerTrackerData('2017-01-01');
            };

            $scope.goBack = () => {
                $scope.innerView = false;
                $scope.mainView = true;
            };

            $scope.propertyName = 'UniqueVisits';
            $scope.reverse = true;
            $scope.sortBy = function(propertyName) {
                $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
                $scope.propertyName = propertyName;
            };

            $scope.getSortDirUnique = () => {
                if($scope.propertyName === 'UniqueVisits' && !$scope.noRecordsFound) {
                    return $scope.reverse ? 'asc' : 'desc';
                }
            };

            $scope.getSortDirVisits = () => {
                if($scope.propertyName === 'TotalVisits' && !$scope.noRecordsFound) {
                    return $scope.reverse ? 'asc' : 'desc';
                }
            };

            $scope.propertyNameInner = 'TotalVisits';
            $scope.reverseInner = true;
            $scope.sortByInner = function(propertyName) {
                $scope.reverseInner = ($scope.propertyNameInner === propertyName) ? !$scope.reverseInner : false;
                $scope.propertyNameInner = propertyName;
            };

            $scope.getSortDirTotalInner = () => {
                if($scope.propertyNameInner === 'TotalVisits' && !$scope.noRecordsFound) {
                    return $scope.reverseInner ? 'asc' : 'desc';
                }
            };

            $scope.getSortDirVisitsInner = () => {
                if($scope.propertyNameInner === 'DaysLastVist' && !$scope.noRecordsFound) {
                    return $scope.reverseInner ? 'asc' : 'desc';
                }
            };
        }]);
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/trackingReportsController.js